import type EtsDeclarationFormData from "entities/etsDeclarationFormData";
import EtsDeclarationResponse from "entities/etsDeclarationResponse";
import EtsSupplyPointListItem from "entities/etsSupplyPointListItem";
import RepositoryBase from "./repositoryBase";

export default class EtsDeclarationRepository extends RepositoryBase {
  getSupplyPoints(partnerId: number) {
    return this.callApi(api => api.all(`partners/${partnerId}/requests/ets_declaration`).getEntities(EtsSupplyPointListItem));
  }

  sendForm(partnerId: number, data: EtsDeclarationFormData) {
    return this.callApi(api =>
      api.all(`partners/${partnerId}/requests/ets_declaration`).postEntity(data, EtsDeclarationResponse)
    );
  }
}
